"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
exports.__esModule = true;
exports.ResponseError = exports.enhanceError = exports.getFinalService = exports.getFinalOptions = exports.assignParams = exports.isString = void 0;
var isObject_1 = __importDefault(require("../shared/isObject"));
var isArray_1 = __importDefault(require("../shared/isArray"));
var isString = function isString(str) {
  return typeof str === 'string';
};
exports.isString = isString;
function assignParams(params, defaultParams) {
  var assignedParams = undefined;
  try {
    if ((0, isObject_1["default"])(params) && (0, isObject_1["default"])(defaultParams)) {
      assignedParams = Object.assign(defaultParams, params);
    } else if ((0, isArray_1["default"])(params) && (0, isArray_1["default"])(defaultParams)) {
      assignedParams = __spreadArray(__spreadArray([], defaultParams, true), params, true);
    } else if ((0, isObject_1["default"])(params)) {
      assignedParams = params;
    }
  } catch (e) {}
  return assignedParams;
}
exports.assignParams = assignParams;
function getFinalOptions(options) {
  var _a, _b, _c, _d, _e, _f, _g;
  var defaultOptions = {
    manual: false,
    defaultLoading: false,
    defaultParams: undefined,
    initialData: undefined,
    update: false,
    formatter: function formatter(res) {
      return res;
    }
  };
  if ((0, isObject_1["default"])(options)) {
    return {
      manual: (options === null || options === void 0 ? void 0 : options.manual) || defaultOptions.manual,
      onSuccess: options === null || options === void 0 ? void 0 : options.onSuccess,
      onError: options === null || options === void 0 ? void 0 : options.onError,
      defaultLoading: (_a = options === null || options === void 0 ? void 0 : options.defaultLoading) !== null && _a !== void 0 ? _a : defaultOptions.defaultLoading,
      defaultParams: (_b = options === null || options === void 0 ? void 0 : options.defaultParams) !== null && _b !== void 0 ? _b : defaultOptions.defaultParams,
      initialData: options === null || options === void 0 ? void 0 : options.initialData,
      formatter: (_c = options === null || options === void 0 ? void 0 : options.formatter) !== null && _c !== void 0 ? _c : defaultOptions.formatter,
      update: (_d = options === null || options === void 0 ? void 0 : options.update) !== null && _d !== void 0 ? _d : false,
      depsEnable: (_e = options === null || options === void 0 ? void 0 : options.depsEnable) !== null && _e !== void 0 ? _e : function () {
        return {};
      },
      deps: (_f = options === null || options === void 0 ? void 0 : options.deps) !== null && _f !== void 0 ? _f : [],
      refreshDeps: (_g = options === null || options === void 0 ? void 0 : options.refreshDeps) !== null && _g !== void 0 ? _g : []
    };
  }
  return __assign(__assign({}, defaultOptions), {
    onError: undefined,
    onSuccess: undefined,
    deps: [],
    refreshDeps: []
  });
}
exports.getFinalOptions = getFinalOptions;
function getFinalService(service) {
  return service;
}
exports.getFinalService = getFinalService;
function enhanceError(error) {
  var err = new ResponseError();
  Object.defineProperties(err, {
    message: {
      value: (0, exports.isString)(error) ? error : error.msg || error.message
    },
    name: {
      value: (0, exports.isString)(error) ? 'ResponseError' : error.name || error.echo
    },
    stack: {
      value: (0, exports.isString)(error) ? new Error('error').stack : error.stack || error.echo || 'error'
    },
    target: {
      value: error
    },
    code: {
      value: (0, exports.isString)(error) ? '-0000' : error.code || '-0000'
    }
  });
  return err;
}
exports.enhanceError = enhanceError;
var ResponseError = /** @class */function (_super) {
  __extends(ResponseError, _super);
  function ResponseError(message) {
    var _this = _super.call(this) || this;
    _this.name = 'ResponseError';
    _this.message = message || 'response error';
    _this.stack = new Error().stack;
    return _this;
  }
  return ResponseError;
}(Error);
exports.ResponseError = ResponseError;